<template>
  <v-app>
    <app-header />
    <app-core-view />
    <app-footer />
    <alert />
  </v-app>
</template>
<script>
import '../../../node_modules/@mdi/font/css/materialdesignicons.css';
import AppFooter from './AppFooter.vue';
import AppHeader from './AppHeader.vue';
import AppCoreView from './AppCoreView.vue';
import Alert from '@/components/Alert';

export default {
  name: 'App',
  components: { AppFooter, AppHeader, AppCoreView, Alert },
};
</script>

<style lang="css">
#app {
  background: white;
}
</style>
